import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Linkedin, Twitter, Instagram, Facebook, Youtube, ChevronUp } from "lucide-react";
import { Box, Container } from "@mui/material";

const Footer = () => {
  const { pathname } = useLocation();
  const [showButton, setShowButton] = useState(false);

  // Utility function to generate paths
  const generatePath = (name) => {
    const cleanName = name
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .trim();
    return `https://indiarisefellowship.in/${cleanName}`;
  };


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const navLinks = [
    { name: "Steering Committee & Core Team" },
    { name: "Fellows" },
    { name: "Program Mentors" },
    { name: "Program Outline" },
    { name: "RISE Curriculum" },
    { name: "Eligibility and Application" },
    { name: "FAQs" },
    { name: "Resources and Opportunities", href: "https://r-o.indiarisefellowship.in/resources-and-opportunities" },
    { name: "RISE Stories" },
    { name: "Past and Upcoming Events" },
    { name: "Join RISE network" },
    { name: "Contact" },
  ];

  const socialLinks = [
    { Icon: Linkedin, href: "https://www.linkedin.com/company/gupta-klinsky-india-institute", label: "LinkedIn" },
    { Icon: Twitter, href: "https://x.com/JHU_India", label: "Twitter" },
    { Icon: Instagram, href: "https://www.instagram.com/jhu_india/", label: "Instagram" },
    { Icon: Facebook, href: "https://www.facebook.com/JHUIndia", label: "Facebook" },
    { Icon: Youtube, href: "https://www.youtube.com/channel/UCseC6yQdbGL4NeX8pwAHE2Q", label: "YouTube" },
  ];

  return (
    <Box component="footer" sx={{ bgcolor: "#003366", color: "white", px: "20px", py: { xs: "40px", md: "48px" }, position: "relative" }}>
      {pathname === "/resources-and-opportunities" && showButton && (
        <Box
          onClick={scrollToTop}
          sx={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            backgroundColor: "#FF9F1C",
            width: "40px",
            height: "40px",
            borderRadius: "8px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 1000,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#ff8c00",
              transform: "translateY(-5px)",
            },
          }}
        >
          <ChevronUp color="white" size={32} />
        </Box>
      )}
      <Container maxWidth="xl">
        {/* Navigation Links */}
        <Box
          component="nav"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: 1,
            mb: 4,
          }}
        >
          {navLinks.map((link, index) => (
            <React.Fragment key={index}>
              <Box
                component="a"
                href={link.href || generatePath(link.name)}
                sx={{
                  fontSize: "0.875rem",
                  px: 1,
                  py: 0.5,
                  borderRadius: 1,
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                {link.name}
              </Box>
              {index < navLinks.length - 1 && (
                <Box
                  component="span"
                  sx={{
                    width: "1px",
                    height: "20px",
                    bgcolor: "#fff",
                    display: "block",
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>

        {/* Social Links */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mb: 4 }}>
          {socialLinks.map(({ Icon, href, label }, index) => (
            <Box
              key={index}
              component="a"
              target="_blank"
              href={href}
              aria-label={label}
              sx={{
                color: "white",
                display: "inline-flex",
                transition: "all 0.3s",
                "&:hover": {
                  color: "#60a5fa",
                },
              }}
            >
              <Icon size={24} />
            </Box>
          ))}
        </Box>

        {/* Footer Bottom */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            pt: 2.5,
            fontSize: "0.875rem",
            opacity: 0.9,
          }}
        >
          <Box>Copyright © {new Date().getFullYear()} India RISE All Rights Reserved</Box>
          <Box>Designed by <a href="https://imaginetventures.com" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>ImagiNET Ventures</a></Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
